import { getUserProfile } from 'app/selectors';
import { useAccess } from 'hooks/useAccess';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { CatalogVariablesOtherTab } from '../types';

const NTC_ADMINISTRATOR_ROLE = 'NTCAdministrator';
const LOCAL_VARIABLE_EDIT_ROLES = ['NTCAdministrator', 'DOAdministrator', 'OCUser'];
const LOCAL_VARIABLE_DELETE_ROLES = ['NTCAdministrator', 'DOAdministrator'];

export const useCatalogVariablesOtherAccess = (tab: CatalogVariablesOtherTab) => {
    const { catalogs: catalogsRules } = useAccess();
    const profileInfo = useSelector(getUserProfile) as { roles?: string[] } | undefined;
    const roles = profileInfo?.roles ?? [];

    const isNtcAdministrator = roles.includes(NTC_ADMINISTRATOR_ROLE);
    const isGlobalTab = tab === CatalogVariablesOtherTab.Global;
    const canEditLocal = roles.some((role) => LOCAL_VARIABLE_EDIT_ROLES.includes(role));
    const canDeleteLocal = roles.some((role) => LOCAL_VARIABLE_DELETE_ROLES.includes(role));

    const canMutateVariables = isGlobalTab ? isNtcAdministrator : canEditLocal;
    const canDeleteVariables = isGlobalTab ? isNtcAdministrator : canDeleteLocal;

    return useMemo(
        () => ({
            isNtcAdministrator,
            canCreateVariable: canMutateVariables,
            canEditDirectory: canEditLocal,
            variablesRules: {
                ...catalogsRules,
                canEdit: canMutateVariables,
                canDelete: canDeleteVariables,
            },
        }),
        [canDeleteVariables, canEditLocal, canMutateVariables, catalogsRules, isNtcAdministrator],
    );
};
